import { jsx as _jsx } from "react/jsx-runtime";
import { accordionTransitionTiming } from "@faire/retailer-visitor-shared/components/Accordion/Accordion";
import { AccordionContext } from "@faire/retailer-visitor-shared/components/Accordion/context";
import React from "react";
import styled from "styled-components";
/**
 * Same as ./Accordion.tsx, except the parent component controls the state
 * @trackcomponent
 * @supersededBy "@faire/web/slate/Accordion/Accordion#Accordion"
 */ export var FullControlAccordion = function(param) {
    var isOpen = param.isOpen, children = param.children, onClick = param.onClick;
    return /*#__PURE__*/ _jsx(AccordionContext.Provider, {
        value: isOpen,
        children: /*#__PURE__*/ _jsx(Wrapper, {
            onClick: onClick,
            children: children
        })
    });
};
var Wrapper = styled.div.withConfig({
    componentId: "sc-1168e149-0"
})([
    "position:relative;width:100%;height:auto;min-height:fit-content;overflow:hidden;cursor:",
    ";",
    ""
], function(param) {
    var onClick = param.onClick;
    return onClick ? "pointer" : "unset";
}, accordionTransitionTiming);
